import {
  values2b27aniquzbrl as values,
  Monthf07k1mw6tgx4 as Month,
} from '../Month.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { EnumSerializer1gj90z0pxhoem as EnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MonthSerializerClass;
function MonthSerializer() {
  if (MonthSerializerClass === VOID) {
    class $ {
      constructor() {
        MonthSerializer_instance = this;
        this.x25_1 = createEnumSerializer('kotlinx.datetime.Month', values());
      }
      az() {
        return this.x25_1.az();
      }
      pz(decoder) {
        return this.x25_1.pz(decoder);
      }
      y25(encoder, value) {
        this.x25_1.oz(encoder, value);
      }
      oz(encoder, value) {
        return this.y25(encoder, value instanceof Month() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'MonthSerializer', VOID, VOID, [KSerializer()]);
    MonthSerializerClass = $;
  }
  return MonthSerializerClass;
}
var MonthSerializer_instance;
function MonthSerializer_getInstance() {
  if (MonthSerializer_instance === VOID)
    new (MonthSerializer())();
  return MonthSerializer_instance;
}
function createEnumSerializer(serialName, values) {
  return new (EnumSerializer())(serialName, values);
}
//region block: exports
export {
  MonthSerializer_getInstance as MonthSerializer_getInstance2qwbrl8lj4d1u,
};
//endregion

//# sourceMappingURL=MonthSerializers.mjs.map
